import React, { useState } from "react";
import ShootingDot from "./ShootingDot";

interface Props {
  lanenumber: number | null;
  shootingstring: string;
  miss:boolean;
}

const ShootingTarget = ({ lanenumber, shootingstring,miss }: Props) => {
  
  if (!shootingstring){
    shootingstring = "";
  }
  if (shootingstring.length < 5){
    while (shootingstring.length < 6)
    {
      shootingstring += "0";
    }
  }
  return (
    <div data-target-lane={lanenumber} className="shooting-target" id="lane1">
      { lanenumber == null ? (<></>) 
      :(
      <div className="shooting-target-lane-number">
        <span>{lanenumber}</span>
      </div>)
      }
      <div className="shooting-target-plate">
        <div className="shooting-target-dots">
          <ShootingDot dotnumber={1} key="1" hit={shootingstring[0]} />
          <ShootingDot dotnumber={2} key="2" hit={shootingstring[1]} />
          <ShootingDot dotnumber={3} key="3" hit={shootingstring[2]} />
          <ShootingDot dotnumber={4} key="4" hit={shootingstring[3]} />
          <ShootingDot dotnumber={5} key="5" hit={shootingstring[4]} />
        </div>
       { miss? <div className="shooting-target-missed">&nbsp;</div> : <></>}
      </div>
    </div>
  );
};

export default ShootingTarget;
